import React, { useState, useEffect } from "react";
import { Box, Paper, Typography, IconButton, Collapse, Slide } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import NotificationsIcon from "@mui/icons-material/Notifications";

const NotificationItem = ({ notification, onClose, index, expanded, onToggleExpand }) => {

    return (
        <Paper
            elevation={3}
            sx={{
                width: 350,
                backgroundColor: "rgba(156, 195, 233, 1)",
                border: "1px solid rgba(76, 143, 209, 0.3)",
                position: "relative",
            }}
        >
            <Box sx={{ p: 1 }}>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        mb: expanded ? 0.5 : 0,
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <NotificationsIcon sx={{ color: "primary.main", fontSize: 20 }} />
                        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "primary.main" }}>
                            {notification.title}
                        </Typography>
                    </Box>
                    <Box>
                        <IconButton size="small" onClick={() => onToggleExpand(notification.id)}>
                            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                        <IconButton size="small" onClick={() => onClose(notification.id)}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </Box>

                <Collapse in={expanded}>
                    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
                        {notification.image && (
                            <img
                                src={notification.image}
                                alt=""
                                style={{ width: 40, height: 40, borderRadius: "50%", objectFit: "cover" }}
                            />
                        )}
                        <Typography
                            variant="body2"
                            sx={{
                                color: "text.secondary",
                                flex: 1,
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                            }}
                        >
                            {notification.body}
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
        </Paper>
    );
};

const NotificationManager = ({ notifications, onClose }) => {
    const [expandedId, setExpandedId] = useState(null);
    const [prevLength, setPrevLength] = useState(0);

    useEffect(() => {
        if (notifications.length > prevLength) {
            const newNotification = notifications[notifications.length - 1];
            setExpandedId(newNotification.id);
        }
        setPrevLength(notifications.length);
    }, [notifications.length]);

    const handleToggleExpand = (id) => {
        setExpandedId(expandedId === id ? null : id);
    };

    if (notifications.length === 0) return null;

    return (
        <Box
            sx={{
                position: "fixed",
                bottom: 20,
                right: 20,
                zIndex: 9999,
                display: "flex",
                flexDirection: "column-reverse",
                gap: 1,
            }}
        >
            {notifications.map((notification, index) => (
                <Slide
                    key={notification.id}
                    direction="left"
                    in={true}
                    timeout={300}
                >
                    <div>
                        <NotificationItem
                            notification={notification}
                            onClose={onClose}
                            index={index}
                            expanded={expandedId === notification.id}
                            onToggleExpand={handleToggleExpand}
                        />
                    </div>
                </Slide>
            ))}
        </Box>
    );
};

export default NotificationManager;
